import { Col, Form, Row } from "antd";
import _isEmpty from "lodash/isEmpty";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import SearchInput from "../../components/SearchInput/SearchInput";
import { useKeyword } from "../../hooks";
import { getMarkets, getMarketsSuggestion } from "../../store/actions/market.actions";
import { DEFAULT_SORTER } from "../../utils/constants";
import { searchQueryGenerator, submitSearchForm } from "../../utils/utils";
import "./SearchMarket.scss";

const SearchMarket = props => {
  const { t } = useTranslation();
  const { pagination, suggestionLoading } = useSelector(state => state.market);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { keyword, setKeyword } = useKeyword({ pagination });

  const onFormFinish = async (value, option) => {
    let sorter = DEFAULT_SORTER;
    if (!_isEmpty(pagination.sort)) {
      const sortArr = pagination.sort.split(",");
      sorter = { field: sortArr[0], order: sortArr[1] };
    }

    const filterCriteria = {};

    if (option?.key) filterCriteria.id = option.key;

    const query = {
      ...pagination,
      currentPage: 1,
      keyword: option?.key ? null : keyword,
      sorter: _isEmpty(keyword) ? sorter : null,
      pageSize: pagination.size,
      filterCriteria,
      labelInValue: !_isEmpty(option) ? option : undefined,
    };

    const _query = searchQueryGenerator(query);
    await dispatch(getMarkets(_query));
  };

  const getOptions = val => dispatch(getMarketsSuggestion(val));

  const _onSubmit = (flag = true, option) => {
    submitSearchForm(flag, option, pagination, form, onFormFinish);
  };

  const _onEnter = () => {
    if (keyword.length) _onSubmit();
  };

  return (
    <div className="market-search">
      <Form form={form} onFinish={onFormFinish}>
        <Row gutter={[16, 16]} className="row-vertical-padding-4">
          <Col xs={24} sm={24} md={6} lg={6} xl={6} xxl={4}>
            <SearchInput
              value={keyword}
              setValue={setKeyword}
              onSelectValue={_onSubmit}
              loading={suggestionLoading}
              getOptions={getOptions}
              onEnter={_onEnter}
              placeholder={t("AdminSearch.MarketPlaceholder")}
              valuePropName="id"
              labelPropNames={["id", "country"]}
              labelSeparator=" / "
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SearchMarket;
